import FormatCurrency from 'components/Common/FormatCurrency'
import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import React from 'react'
import { connect } from 'react-redux'
import { useLowestFlightPrice } from 'tripPlanner/hooks/api'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary;
  filters?: App.OfferListFilters;
  currency: string;
  region: string;
  totalPrice: number;
  hotelNights: number;
  closestAirportCode: string;
}

export const BedbankTileFlightPrice = (props: Props) => {
  const {
    offer,
    filters,
    hotelNights,
    totalPrice,
    currency,
    region,
    closestAirportCode,
  } = props

  const { data: flightPrice } = useLowestFlightPrice({
    originAirportCode: closestAirportCode,
    destinationAirportCode: offer.flights?.airportCode || '',
    currencyCode: currency,
    regionCode: region,
    nights: hotelNights,
    numberOfAdults: 2,
    shouldQuery: true,
    checkIn: filters?.checkIn,
    checkOut: filters?.checkOut,
  })

  return <>
    <LinePlaneFlyIcon size="XS" colour="primary" />
    {!!flightPrice && <>Hotel + flight package from <FormatCurrency value={flightPrice + totalPrice} /> (2 adults)</>}
    {!flightPrice && 'Hotel + flight package available'}
  </>
}

const mapStateToProps = (state: App.State) => ({
  currency: state.geo.currentCurrency,
  region: state.geo.currentRegionCode,
  closestAirportCode: state.geo.closestAirport.code,
})

export default connect(mapStateToProps)(BedbankTileFlightPrice)
